// extracted by mini-css-extract-plugin
module.exports = {"message":"PayoutDetailsTab_message__2UhTa"};